
import { buildWordList, parseLichessCommands, parseComputerCommands, parsePlay, 
                    parseGameWordsSaid, processDescribe, wordToSayForColumn, 
                    wordToSayForPieceLetter }
                    from '@/composables/parsePlay.js'

import { translateEnglishWords } from '@/composables/translation';

const columnLetters = ['a', 'b', 'c', 'd','e','f','g','h']

export function toRankWord(rank) {
  const rankWords = ["zero", "one", "two", "three", "four", "five", "six", "seven", "eight"]
  const rankNumber = (typeof rank === 'string') ? Number(rank) : rank
  return (rankWords[rankNumber])
}

export function buildPieceLocationStrings (board,isPlayingWhite) {
  var whiteKing = ""
  var whiteQueens = []
  var whiteRooks = []
  var whiteBishops = []
  var whiteKnights = []
  var whitePawns = []

  var blackKing = ""
  var blackQueens = []
  var blackRooks = []
  var blackBishops = []
  var blackKnights = []
  var blackPawns = []

  var whitePieces = []
  var blackPieces = []

  
  //console.log("*** BOARD",board)

  for (var row=0; row < 8; row++) {
    for (var col=0; col < 8; col++) {
      if (board[row][col] == null)
        continue
      const oneSquare = board[row][col]
      //console.log("oneSquare",oneSquare)
      const san = ((oneSquare.type == 'p') ? "" : oneSquare.type.toUpperCase()) + oneSquare.square
      //console.log("square row col ",row,col,san)
      if (oneSquare.color == 'b') {
        switch (oneSquare.type) {
          case 'k' :
            blackKing = san
            break
          case 'q' :
            blackQueens.push(san)
            break
          case 'r' :
            blackRooks.push(san)
            break
          case 'b' :
            blackBishops.push(san)
            break
          case 'n' :
            blackKnights.push(san)
            break;
          case 'p' :
            blackPawns.push(san)
            break;
        }
      }
      else {
        switch (oneSquare.type) {
          case 'k' :
            whiteKing = san
            break
          case 'q' :
            whiteQueens.push(san)
            break
          case 'r' :
            whiteRooks.push(san)
            break
          case 'b' :
            whiteBishops.push(san)
            break
          case 'n' :
            whiteKnights.push(san)
            break;
          case 'p' :
            whitePawns.push(san)
            break;
        }
      }
    }
  }
  whitePieces.push(whiteKing)
  whiteQueens.forEach((currentElement) => { whitePieces.push(currentElement) })
  whiteRooks.forEach((currentElement) => { whitePieces.push(currentElement) })
  whiteBishops.forEach((currentElement) => { whitePieces.push(currentElement) })
  whiteKnights.forEach((currentElement) => { whitePieces.push(currentElement) })
  whitePawns.forEach((currentElement) => { whitePieces.push(currentElement) })

  blackPieces.push(blackKing)
  blackQueens.forEach((currentElement) => { blackPieces.push(currentElement) })
  blackRooks.forEach((currentElement) => { blackPieces.push(currentElement) })
  blackBishops.forEach((currentElement) => { blackPieces.push(currentElement) })
  blackKnights.forEach((currentElement) => { blackPieces.push(currentElement) })
  blackPawns.forEach((currentElement) => { blackPieces.push(currentElement) })

  const whitePieceString = "White : " + whitePieces.join(" ")
  const blackPieceString = "Black : " + blackPieces.join(" ")
  //console.log("white",whitePieceString)
  //console.log("black",blackPieceString)
  //console.log("orientation in initial",orientation.value)
  if (isPlayingWhite) {
  
    return {your : whitePieceString, opponent : blackPieceString}
  }
  return {your : blackPieceString, opponent : whitePieceString}
}

export function listOfSquaresWithNewPieces(originalBoard,newBoard) {
  //console.log("***** ORIGINAL ",originalBoard)
  //console.log("***** NEW      ",newBoard)
  var ucis = []
  for (var row=0; row < 8; row++)
    for (var col=0; col < 8; col++) {
      const oneOriginal = originalBoard[row][col]
      const oneNew = newBoard[row][col]
      if (oneNew == null)
        continue
      if (oneOriginal == null) {
        ucis.push(oneNew.square)
        continue
      }
      if (oneOriginal.type == oneNew.type && oneOriginal.color == oneNew.color)
        continue
      ucis.push(oneOriginal.square)
    }
  return (ucis)
}

// builds the KQkq string based on if the king and rooks are in the right place
export function buildCastleString(board) {

  var blackQueenRook = false
  var blackKingRook = false
  var blackKing = false
  var whiteQueenRook = false
  var whiteKingRook = false
  var whiteKing = false

  var castleString = ""

  for (var row=0; row < 8; row++)
    for (var col=0; col < 8; col++) {
      const oneSquare = board[row][col]
      if (oneSquare == null)
        continue
      switch (oneSquare.square) {
        case "a8" :
          blackQueenRook = (oneSquare.type == 'r' && oneSquare.color == 'b')
          break
        case "h8" :
          blackKingRook = (oneSquare.type == 'r' && oneSquare.color == 'b')
          break
        case "e8" :
          blackKing = (oneSquare.type == 'k' && oneSquare.color == 'b')
          break
        case "a1" :
          whiteQueenRook = (oneSquare.type == 'r' && oneSquare.color == 'w')
          break
        case "h1" :
          whiteKingRook = (oneSquare.type == 'r' && oneSquare.color == 'w')
          break
        case "e1" :
          whiteKing = (oneSquare.type == 'k' && oneSquare.color == 'w')
          break
      }
    }
  if (whiteKing) {
    if (whiteKingRook)
      castleString += "K"
    if (whiteQueenRook)
      castleString += "Q"
  }

  if (blackKing) {
    if (blackKingRook)
      castleString += "k"
    if (blackQueenRook)
      castleString += "q"
  }

  if (castleString.length == 0)
    return ("-")
  return (castleString)
}

export function getPieceSetName(blindfoldLevel) {
  const blindfoldValue = (typeof blindfoldLevel === 'string') ? parseInt(blindfoldLevel) : blindfoldLevel
  switch (blindfoldValue) {
    case 0 :
    case 1 :
      return ("regular")
      break
    case 2 : 
      //console.log("set blindness 2")
      return ("one_color")
      break
    case 3 :
      return ("two_disks")
      break
    case 4 :
      return ("one_disk")
      break
    case 5 :
      return ("invisible")
      break
  }
  return ("regular")
}

export function columnToNumber(letter) {
  for (var i =0; i < 8; i++)
    if (letter == columnLetters[i])
      return (i)
  return (0)
}

export function squarePairToAlgebraic(pair) {
  const squares = [Math.floor(pair / 100) , (pair % 100)]

  //console.log("squares ",squares)
  var notation = []
  for (var i=0; i < 2; i++) {
    const row = 8 - Math.floor(squares[i] / 8)
    const col = squares[i] % 8
    const n = columnLetters[col] + row
    notation.push(n)
  }
  const stringForArrow = notation.join("-")
  return (stringForArrow)
}

// uses chess.js to get the list of moves. This parses that list and builds "Available Moves"
//      chess.load(fen)
//      const moves = chess.moves({ verbose: true })

export function buildAvailableMoves(moves,allowAnyPromotion) {
  var promotion = ""
  var availableMoves = []
  for (var i=0; i < moves.length; i++) {
    const oneChessMove = moves[i]

    // ignore any promotions other than queen if allowAnyPromotion == false
    if (oneChessMove.hasOwnProperty('promotion') && oneChessMove.promotion != undefined) {
      if (!allowAnyPromotion)
        if (oneChessMove.promotion != 'q')
          continue;
        else
          promotion = ""
      else
        promotion = oneChessMove.promotion
    }
    else
      promotion = ""

    var tmp = oneChessMove.from.split("")
    var colNumber = columnToNumber(tmp[0])
    const fromSquareNumber = (8 - tmp[1]) * 8 + colNumber

    tmp = oneChessMove.to.split("")
    colNumber = columnToNumber(tmp[0])
    const toSquareNumber = (8 - tmp[1]) * 8 + colNumber

    const toArray = oneChessMove.to.split("")
    const fromArray = oneChessMove.from.split("")

    const oneMove = {
            chessJS : oneChessMove,
            fen : oneChessMove.after,
            from : fromSquareNumber,
            to : toSquareNumber,
            san : oneChessMove.san,
            promotion : promotion}
    availableMoves.push(oneMove)
  }
  return (availableMoves)
}

function getPieceName(piece) {
   switch (piece) {
    case "r" :
      return ("Rook")
      break
    case "n" :
      return ("Knight")
      break
    case "b" :
      return ("Bishop")
      break
    case "q" :
      return ("Queen")
      break
    case "k" :
      return ("King")
      break
    case "p" :
      return ("Pawn")
      break
  }
  return ("?")
}

function addCheckText(isCheck,isCheckMate) {

  if (isCheck)
    return ("\t" + translateEnglishWords("check"))
  if (isCheckMate)
      return ("\t" + translateEnglishWords("check") + " " + translateEnglishWords("mate"))
  return ("")
}

export function buildVerbalSan(chessJS,sayFileWords) {

  //console.log("file words in buildverbal",sayFileWords)
  var speak = ""

  const piece = chessJS.piece
  const san = chessJS.san
  const promotion = chessJS.promotion
  
  const isCastle = san.includes("O-O")
  const isQueenCastle = san.includes("O-O-O")
  const isCheck = san.includes("+")
  const isCheckMate = san.includes("#")
  const isPromotion = san.includes("=")
  const isCapture = san.includes("x")

 
  // deal with castle and get it out of the way
  if (isCastle) {
    const castleString = translateEnglishWords("castle")
    const queenString = translateEnglishWords("queen")
    const sideString = translateEnglishWords("side")
    speak = (isQueenCastle) ? castleString + " " + queenString + " " + sideString : castleString
    speak += addCheckText(isCheck,isCheckMate)
    //console.log("speak",speak)
    return (speak)
  }

  // get the file and rank appearances
  var files = []
  var ranks = []
  for (var i=0; i < san.length; i++) {
    const oneLetter = san[i]
    if (oneLetter >= '1' && oneLetter <= '8')
      ranks.push(oneLetter)
    else
    if (oneLetter >= 'a' && oneLetter <= 'h')
      files.push(oneLetter)
  }
  //console.log("files and ranks", ranks,files)

  const takesString = translateEnglishWords("takes")
  const toString = translateEnglishWords("to")

  // if it is a pawn, could be a move forward, capture, with promotion, check, checkmate
  if (piece == "p") {
    if (isCapture) {
      const fromFile = files[0]
      const fromFileString = translateEnglishWords(wordToSayForColumn(columnToNumber(fromFile),sayFileWords))
      const toFile = files[1]
      const toFileString = translateEnglishWords(wordToSayForColumn(columnToNumber(toFile),sayFileWords))
      const rank = translateEnglishWords(toRankWord(ranks[0]))
      speak = fromFileString + " " + takesString + " " + toFileString + " " + rank
    }
    else {
      const file = files[0]
      const fileString = translateEnglishWords(wordToSayForColumn(columnToNumber(file),sayFileWords))
      const rank = translateEnglishWords(toRankWord(ranks[0]))

      // if file is "a" then say "pawn to" because it frequently is said as a "short a"
      if (file == "a" && sayFileWords != "words" && sayFileWords != "names")
        speak = translateEnglishWords("pawn") + " " + fileString + " " + rank
      else
        speak = fileString + " " + rank
    }
    if (isPromotion) {
      const promotesTo = translateEnglishWords(wordToSayForPieceLetter(promotion))
      const promotesString = translateEnglishWords("promotes")
      speak += " " + promotesString + " " + toString + " " + promotesTo
    }
    speak += addCheckText(isCheck,isCheckMate)
    //console.log("speak",speak)
    return (speak)
  }

  // handle the 4 "from" location possibilities: nothing, file, rank file&rank
  const pieceName = translateEnglishWords(wordToSayForPieceLetter(piece))
  var toFile = ""
  var toRank = ""
  speak = pieceName
  if (files.length == 2) {
    const fromFile = files[0]
    const fromFileString = translateEnglishWords(wordToSayForColumn(columnToNumber(fromFile),sayFileWords))
    toFile = translateEnglishWords(wordToSayForColumn(columnToNumber(files[1]),sayFileWords))
    if (ranks.length == 2) {
      const fromRank = translateEnglishWords(toRankWord(ranks[0]))
      toRank = translateEnglishWords(toRankWord(ranks[1]))
      speak += " " + translateEnglishWords("on file") + " " + fromFileString + " " + 
                        translateEnglishWords("and on rank") + " " + fromRank
    }
    else {
      toRank = translateEnglishWords(toRankWord(ranks[0]))
      speak += " " + translateEnglishWords("on file") + " " + fromFileString
    }
  }
  else {
    toFile = translateEnglishWords(wordToSayForColumn(columnToNumber(files[0]),sayFileWords))
    if (ranks.length == 2) {
      const fromRank = translateEnglishWords(toRankWord(ranks[0]))
      toRank = translateEnglishWords(toRankWord(ranks[1]))
      speak += " " + translateEnglishWords("on rank") + " " + fromRank
    }
    else
      toRank = translateEnglishWords(toRankWord(ranks[0]))
  }
  const action = (isCapture) ? takesString : toString
  speak += " " + action
  speak += " " + toFile + " " + toRank 
  speak += addCheckText(isCheck,isCheckMate)

  //console.log("speak",speak)
  return (speak)
}

export function buildHTMLTableFromAscii(ascii) {
  const lines = ascii.split("\n")

  var html = []
  html.push("<table role='grid'>")
  for (var i=1; i <= 8; i++) {
    const oneLine = lines[i].substring(5,27)
    console.log("line", i, oneLine)
    const squares = oneLine.split("  ")
    console.log("squares", squares)
    html.push("<tr>")
    const rowNumber = 9 - i
    for (var file=0; file < 8; file++) {
        const coordinatePart = columnLetters[file].toUpperCase() + " " + rowNumber
        html.push("<td>")
        const oneChar = squares[file]
        if (oneChar == ".")
          html.push(coordinatePart)
        else
        if (oneChar > 'a' && oneChar <= 'z')
          html.push("Black " + getPieceName(oneChar) + " " + coordinatePart)
        else
          html.push("White " + getPieceName(oneChar.toLowerCase()) + " " + coordinatePart)
        html.push("</td>")
    }
    html.push("</tr>")
  }
  html.push("</table>")
  console.log("html array",html)
  const htmlString = html.join("")
  console.log("html string", htmlString)
  return (htmlString)
}